import { FC, useEffect, useState } from 'react';
import './ModalArticleView.scss';
import ModalDefault from '../../../components/ModalDefault/ModalDefault';
import { Card, Col, FormGroup, Row } from 'react-bootstrap';
import { useArticles } from '../../../providers/Articles/ArticlesProvider';
import { ArticlesModel } from '../../../models/Articles/ArticleModel';
import getFileParts from '../../../utils/GetFileParts';
import { BvIcon } from 'bevi-icon';

interface ModalArticleViewProps {
  show: boolean;
  onClose: () => void;
  article?: ArticlesModel | null;
}

const ModalArticleView: FC<ModalArticleViewProps> = ({ show, onClose, article }) => {
  const [isActive, setIsActive] = useState<boolean>(true);
  const [htmlContent, setHtmlContent] = useState<any>("");

  const { setError } = useArticles();

  const handleClose = () => {
    setError('');
    onClose();
  }

  const handleStep = () => {
    setIsActive((prev) => !prev);
  };

  const renderMenu = () => {
    return (
      <ul className="nav nav-tabs m-0">
        <li className="nav-item">
          <a
            onClick={handleStep}
            className={`nav-link ${isActive ? "active" : ""}`}
            href="#"
          >
            Conteúdo Usuário
          </a>
        </li>
        <li className="nav-item">
          <a
            onClick={handleStep}
            className={`nav-link ${!isActive ? "active" : ""}`}
            href="#"
          >
            Conteúdo IA
          </a>
        </li>
      </ul>
    );
  };

  const renderContent = (content?: string) => {
    return (
      <div>
          <Card className="content-card">
              <Card.Body>
                  <div
                    className="content"
                    dangerouslySetInnerHTML={{
                      __html: content ?? "",
                    }}
                  />
              </Card.Body>
          </Card>
      </div>
    );
  };

  useEffect(() => {
    if (show) {
      setHtmlContent(article?.content);
    }
  }, [show]);

  return (
    <ModalDefault
      title={`Visualizar Artigo - #${article?.id}<br/><span class="mt-2 mb-0 text-sm ms-2">${article?.title}</span>`}
      show={show}
      onClose={handleClose}
      sizeModal={'xl'}
      showFooter={true}
      backdrop="static"
      backgroundColor="#f8f9fa"
      disableEsc={false}
    >
      <div className="ModalArticleView" data-testid="ModalArticleView">
        <Row>
          <Col md={8}>
            {renderMenu()}
            {renderContent(isActive ? article?.content : article?.content_ia)}
          </Col>
          <Col md={4}>
            <Card className="wrapper">
              <Card.Body>
                <Row>
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="category" className="ms-0">CATEGORIA</label>
                      <p className="m-0"><b>{article?.category?.name ? article?.category?.name : '-'}</b></p>
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="section" className="ms-0">SEÇÃO</label>
                      <p className="m-0"><b>{article?.section?.name ? article?.section?.name : '-'}</b></p>
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="subsection" className="ms-0">SUBSEÇÃO</label>
                      <p className="m-0"><b>{article?.subsection?.name ? article?.subsection?.name : '-'}</b></p>
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="access_profile_articles" className="ms-0">NÍVEIS DE ACESSO</label>
                      {(article?.access_profile_articles && article?.access_profile_articles?.length > 0) ? (
                        <>
                          {article?.access_profile_articles.map((item: any) => (
                            <div className="badge badge-primary">{item?.name}</div>
                          ))}
                        </>
                      ) : (
                        <p className="mb-0">-</p>
                      )}
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="related_articles" className="ms-0">ARTIGOS RELACIONADOS</label>
                      {(article?.related_articles && article?.related_articles?.length > 0) ? (
                        <>
                          {article?.related_articles.map((item: any) => (
                            <div className="badge badge-primary">{item?.name}</div>
                          ))}
                        </>
                      ) : (
                        <p className="mb-0">-</p>
                      )}
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="tags" className="ms-0">TAGS</label>
                      {(article?.tags && article?.tags?.length > 0) ? (
                        <>
                          {article?.tags.map((item: any) => (
                            <div className="badge badge-primary">{item?.name}</div>
                          ))}
                        </>
                      ) : (
                        <p className="mb-0">-</p>
                      )}
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="model_name" className="ms-0">MODELO</label>
                      <p className="m-0"><b>{article?.model_name ? article?.model_name : '-'}</b></p>
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="prompt_article" className="ms-0">PROMPT ARTIGO</label>
                      <textarea
                      id="prompt_article"
                        className="form-control"
                        rows={10}
                        disabled
                        style={{ resize: "block" }}
                      >
                        {article?.prompt_article ?? ""}
                      </textarea>
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="is_internal" className="ms-0">ARTIGO INTERNO?</label>
                      <p className="m-0"><b>{article?.is_internal ? 'SIM' : 'NÃO'}</b></p>
                    </FormGroup>
                  </Col>
                  <hr />
                  <Col md={12}>
                    <FormGroup className="form-group">
                      <label htmlFor="is_file" className="ms-0">POSSUI ARQUIVO EXCEL IA?</label>
                      <p className="m-0"><b>{article?.is_file ? 'SIM' : 'NÃO'}</b></p>

                      {article?.list_file && article?.list_file.length > 0 && (
                        <>
                          <ul className="d-flex flex-column list-unstyled px-3">
                            {article?.list_file.map((item: any, key2: number) => (
                              <>
                                {key2 > 0 && (<hr className="bg-primary"/>)}
                                <a href={`${process.env.REACT_APP_BEVIAJUDA_API}${item.filename}`} download>
                                  <li className={`d-flex flex-row gap-2 justify-content-between align-items-center ${key2 == 0 && 'mt-4'}`}>
                                      <div>
                                        <i className="fa-solid fa-file-excel text-primary"></i>  
                                      </div>
                                      <div className="file-name-wrapper">
                                        <p className="m-0">{getFileParts(item.filename).name}.{getFileParts(item.filename).ext}</p>
                                      </div>
                                      <div style={{width: 48}}>
                                        <BvIcon name="download" variant="duo" width={64}></BvIcon>
                                      </div>
                                  </li>
                                </a>
                              </>
                            ))}
                          </ul>
                        </>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </ModalDefault>
  );
}

export default ModalArticleView;
